import React from "react"
import "./AboutEvent.scss"
import { StaticImage } from "gatsby-plugin-image"
import { Player } from "@lottiefiles/react-lottie-player"
import DecoLine01 from "@lotties/deco-line01.json"
import DecoLine02 from "@lotties/deco-line02.json"
import Division from "@lotties/division.json"
import DecoLineShort01 from "@lotties/deco-line01-short.json"
import DecoLineShort02 from "@lotties/deco-line02-short.json"
import DivisionShort from "@lotties/division-short.json"

const AboutEvent = () => {
  return (
    <section className="about-event" id="about-event">
      <div className="about-event-inner">
        <div className="about-event-container">
          <div className="about-event-logo"></div>
          <h2 className="section-title about-event-title">
            Welcome to
            <br /> V4Mirai 1st Live Concert
            <br /> - Mirai Wonderland
          </h2>
          <p className="about-event-text">
            Join us in our Mirai Wonderland! Our first live concert and to make
            it extra special, it’s a two night affair! Our talents have been
            working long and hard perfecting this performance, and we invite you
            to partake in the celebration of their efforts! Hear heart thumping
            originals, some classic convers, and perhaps a winter surprise or
            two to keep up the cheer on a cold snowy night! Best of all, The
            Mirai Wonderland live concert is totally free! Just get online and
            dive into the V4 Fun!
          </p>
          <div className="about-event-banners">
            {/* <a
              href="https://www.youtube.com/live/k7kz93V99RY"
              target="_blank"
              rel="noreferrer"
              className="about-event-banner"
              data-gtm-click="aboutEvent-getNotified"
            ></a> */}
            <a
              href="https://www.youtube.com/live/tqmxQ0eBVCQ"
              target="_blank"
              rel="noreferrer"
              className="about-event-banner-archive-day1"
              data-gtm-click="aboutEvent-archiveDay1"
            ></a>
            <a
              href="https://www.youtube.com/live/k7kz93V99RY"
              target="_blank"
              rel="noreferrer"
              className="about-event-banner-archive-day2"
              data-gtm-click="aboutEvent-archiveDay2"
            ></a>
          </div>
        </div>
        <div className="about-event-ornament">
          <Player
            className="deco-line1-sp"
            autoplay
            loop
            src={DecoLineShort01}
          />
          <Player
            className="deco-line2-sp"
            autoplay
            loop
            src={DecoLineShort02}
          />
          <Player className="deco-line4-sp" autoplay loop src={DivisionShort} />
          <Player className="deco-line1" autoplay loop src={DecoLine01} />
          <Player className="deco-line2" autoplay loop src={DecoLine02} />
          <Player className="deco-line4" autoplay loop src={Division} />
          <div className="barcode">
            <StaticImage src="../../images/icon/icn-barcode.svg" alt="" />
          </div>
          <div className="about-event-ornament-img1">
            <StaticImage
              src="../../images/icon/snow-flake/snowflake01-fv.png"
              alt=""
            />
          </div>
          <div className="about-event-ornament-img2">
            <StaticImage
              src="../../images/icon/snow-flake/snowflake02-fv.png"
              alt=""
            />
          </div>
          <div className="about-event-ornament-img4">
            <StaticImage
              src="../../images/icon/snow-flake/snowflake04-fv.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutEvent
